import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles";

const useStyles = makeStyles((theme: Theme) => ({
  standard: {
    fontSize: theme.fontSizes.default,
    color: theme.colors.defaultTextColor,
  },
  text: {
    fontSize: theme.fontSizes.default,
    [theme.breakpoints.down("desktop")]: {
      fontSize: theme.fontSizes.md,
    },
  },
  headerTitle: {
    fontSize: theme.fontSizes.lg,
    color: theme.colors.greenText,
    fontWeight: 500,
    [theme.breakpoints.down("desktop")]: {
      fontSize: theme.fontSizes.default,
    },
  },
  large: {
    fontSize: theme.fontSizes.lg,
  },
  light: {
    letterSpacing: "1px",
  },
  bigTitle: {
    fontSize: theme.fontSizes.xxl,
    color: theme.colors.obsidian,
    [theme.breakpoints.down("desktop")]: {
      fontSize: theme.fontSizes.lg,
    },
  },
  clickable: {
    cursor: "pointer",
  },
}));

export default useStyles;
